<template>
  <div>
    <vue-loading v-if="loading"></vue-loading>
    <div v-else>
      <h1>{{ room.roomName }}</h1>
      <item-list v-if="room.roomId != null" v-bind:roomId="room.roomId"></item-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ItemList from './children/ItemList.vue'
export default {
  name: 'Room',
  components: {
    'item-list': ItemList
  },
  data: () => ({
    loading: true,
    room: {
      roomId: null,
      roomName: null
    }
  }),
  computed: {
    ...mapGetters({
      session: 'getSession',
      roomNames: 'getAllRoomNames',
      rooms: 'getAllRooms'
    })
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('loadAllRoomNames').then(() => {
        this.$store.dispatch('loadAllRooms').then(() => {
          var room = this.rooms.filter((item) => {
            return Number(item.roomId) === Number(this.session.roomId)
          })
          room = room[0]
          var roomName = this.roomNames.filter((roomName) => {
            return Number(roomName.roomNameId) === Number(room.roomNameId)
          })
          room.roomName = roomName[0].roomName
          this.room = room
          this.loading = false
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Room.vue